<template>
    <svg
        width="660"
        height="406"
        viewBox="0 0 660 406"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <text
            fill="var(--et-colors-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="60"
            font-weight="bold"
            letter-spacing="0em"
        >
            <tspan x="147" y="204.2">30</tspan>
        </text>
        <text
            fill="var(--et-colors-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="20"
            letter-spacing="0em"
        >
            <tspan x="164" y="242.9">days</tspan>
        </text>
        <text
            fill="var(--et-colors-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="60"
            font-weight="bold"
            letter-spacing="0em"
        >
            <tspan x="249" y="204.2">13</tspan>
        </text>
        <text
            fill="var(--et-colors-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="20"
            letter-spacing="0em"
        >
            <tspan x="254" y="242.9">hours</tspan>
        </text>
        <text
            fill="var(--et-colors-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="60"
            font-weight="bold"
            letter-spacing="0em"
        >
            <tspan x="340" y="204.2">10</tspan>
        </text>
        <text
            fill="var(--et-colors-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="20"
            letter-spacing="0em"
        >
            <tspan x="335" y="242.9">minutes</tspan>
        </text>
        <text
            fill="var(--et-colors-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="60"
            font-weight="bold"
            letter-spacing="0em"
        >
            <tspan x="436" y="204.2">22</tspan>
        </text>
        <text
            fill="var(--et-colors-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="20"
            letter-spacing="0em"
        >
            <tspan x="434" y="242.9">seconds</tspan>
        </text>
    </svg>
</template>
